<template>
  <Modal v-model="open" size="tiny" :title="title" titleAlign="center" close>
    <div class="text-center" v-if="type === 1">
      {{ message }}

      <div class="confirm-buttons">
        <Button type="error" @click="() => handleClose(true)">Cancelar</Button>
        <Button type="success" @click="() => handleClose(false)">Confirmar</Button>
      </div>
    </div>
    <div v-if="type === 2">
      <b-row align="center">
        <b-col>
          <AlertCircleOutline class="icon-2x" title="Alerta" />
        </b-col>
      </b-row>
      <b-row align="center" class="mt-2 mb-3">
        <b-col>
          <h2>{{ message }}</h2>
        </b-col>
      </b-row>
      <b-row align="center">
        <b-col>
          <Button type="cancel" @click="handleClose(true)" v-if="textButtonCancel !== ''">
            <Close class="mb-1" :title="textButtonCancel" /> {{ textButtonCancel }}
          </Button>
          <Button @click="handleClose(false)" type="success">{{ textButtonOk }}</Button>
        </b-col>
      </b-row>
    </div>
  </Modal>
</template>

<script>
import Close from 'vue-material-design-icons/Close.vue';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue';
import Modal from '../Modal';
import { Button } from '../Form';

export default {
  name: 'Confirm',
  components: {
    Modal,
    Button,
    AlertCircleOutline,
    Close,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    handleClose(cancel) {
      this.$emit('input', false);
      if (cancel) {
        this.onCancel();
        return;
      }

      this.onOk();
    },
  },
  watch: {
    value(newValue) {
      this.open = newValue;
    },
    open(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    message: {
      type: String,
    },
    textButtonOk: {
      type: String,
      default: 'Confirmar',
    },
    textButtonCancel: {
      type: String,
      default: 'Cancelar',
    },
    type: {
      type: Number,
      default: () => 1,
    },
    onCancel: {
      type: Function,
      default: () => () => null,
    },
    onOk: {
      type: Function,
      required: true,
      default: () => () => null,
    },
    value: {
      required: true,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.icon-2x {
  color: #f8bb86;
  height: 7.5em;
  width: 7.5em;
}

.icon-2x > .material-design-icon__svg {
  height: 7.5em;
  width: 7.5em;
}
</style>
